import { useMutation, useQuery } from "@tanstack/react-query";
import { Profile, TChangePin, TProfile } from "../utils/types";
import ws from "@/utils/service";
import { formatMobileNumber } from "@/utils/formatMobileNumber";
import toast from "react-hot-toast";
import { useAuth } from "@/context/auth-context";
import { transformProfile } from "../utils/transformers";
import { queryClient } from "@/utils/react-query-client";

export const initialProfileForm: TProfile = {};

export const changePinForm: TChangePin = {};

export function refreshProfile() {
  queryClient.invalidateQueries(["PROFILE"] as any);
}

export const useProfile = () => {
  const authState = useAuth();
  return useQuery({
    queryKey: ["PROFILE"],
    queryFn: async () => {
      const res = await ws.get("/api/v1/taxpayers/profile");
      const user = transformProfile(res?.data?.data?.attributes);
      const updatedAuthState = { ...authState.authState, user };
      authState.setAuthState(updatedAuthState);
      sessionStorage.setItem("session", JSON.stringify(updatedAuthState));
      return user;
    },
    enabled: Boolean(authState?.authState?.token)
  });
};

export const useUpdateProfile = () => {
  return useMutation({
    mutationFn: async ({ payload }: { payload: Profile }) => {
      return ws.put("/api/v1/taxpayers/update/profile", formatMobileNumber(payload));
    },
    onSuccess: () => {
      refreshProfile();
      toast.success("Saved!");
    }
  });
};

export const useChangePin = () => {
  return useMutation({
    mutationFn: async ({ payload }: { payload: TChangePin }) => {
      return ws.put("/api/v1/taxpayers/change_pin", payload);
    },
    onSuccess: () => {
      refreshProfile();
      toast.success("Your PIN successfully changed!");
    }
  });
};
